export default {
  title: 'Kazaar Local',
  faviconPath: '/static/icons/favicon.ico',
  defaultCss: 'default.css',
};
